import {
  FlexBox,
  SPACING,
  Typography,
  JoonUIColor,
  DoterSpecies,
} from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import OnboardingPageContentWrapper from "./onboardingPageContentWrapper/OnboardingPageContentWrapper"
import { BACKGROUND_COLORS } from "../../constants"
import useOnboardContext from "../../hooks/useOnboardContext"
import ParentAvatarButton from "../../pages/family/ParentAvatarButton"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import ChevronBackButton from "../buttons/ChevronBackButton"
import Primary3DButton from "../buttons/Primary3DButton"
import ParentAvatar from "../parentAvatar/ParentAvatar"
import TextInputRect from "../textInputRect/TextInputRect"

function OnboardParentAvatarSection() {
  const [warningText, setWarningText] = useState("")
  const { parentData, nextStep, previousStep, setParentData } =
    useOnboardContext()
  const { t } = useTranslation()

  return (
    <OnboardingPageContentWrapper
      paddingTop="5dvh"
      style={{ position: "relative" }}
      backgroundOnDesktop={BACKGROUND_COLORS.lightBlueBg}
    >
      <ChevronBackButton onClick={previousStep} />
      <FlexBox direction="column" align="center" gap={SPACING.space6}>
        {parentData.avatar ? (
          <ParentAvatar avatar={parentData.avatar} className="rounded-full" />
        ) : (
          <img
            src={"/images/parentDoterAssets/Placeholder_Ferox.png"}
            alt="parent avatar"
            style={{ width: "100px", height: "100px", borderRadius: "100%" }}
          />
        )}
        <Typography variant="h2Serif" textAlign="center">
          {t("PARENT_AVATAR_TITLE")}
        </Typography>
        <FlexBox direction="column" gap={SPACING.space1}>
          <Typography variant="body">
            {t("PARENT_AVATAR_NICKNAME_LABEL")}
          </Typography>
          <Typography variant="bodyXSmall">
            {t("PARENT_AVATAR_NICKNAME_HELP")}
          </Typography>
          <TextInputRect
            fullWidth
            name="nickName"
            placeholder={t("PARENT_AVATAR_NICKNAME_PLACEHOLDER")}
            onChange={(e: any) => setParentData("nickname", e.target.value)}
            value={parentData.nickname}
          />
        </FlexBox>

        <FlexBox direction="column" gap={SPACING.space1}>
          <Typography variant="body">
            {t("PARENT_AVATAR_AVATAR_LABEL")}
          </Typography>
          <Typography variant="bodyXSmall">
            {t("PARENT_AVATAR_AVATAR_HELP")}
          </Typography>

          <div className="flex flex-row w-full gap-1">
            <ParentAvatarButton
              avatar={DoterSpecies.DRAGON}
              isSelected={parentData.avatar === DoterSpecies.DRAGON}
              setSelectedParentAvatar={() => {
                trackAnalyticEvent(ANALYTIC_EVENTS.SELECT_PARENT_AVATAR)
                setParentData("avatar", DoterSpecies.DRAGON)
              }}
            />
            <ParentAvatarButton
              avatar={DoterSpecies.BEAR}
              isSelected={parentData.avatar === DoterSpecies.BEAR}
              setSelectedParentAvatar={() => {
                trackAnalyticEvent(ANALYTIC_EVENTS.SELECT_PARENT_AVATAR)
                setParentData("avatar", DoterSpecies.BEAR)
              }}
            />
            <ParentAvatarButton
              avatar={DoterSpecies.FOX}
              isSelected={parentData.avatar === DoterSpecies.FOX}
              setSelectedParentAvatar={() => {
                trackAnalyticEvent(ANALYTIC_EVENTS.SELECT_PARENT_AVATAR)
                setParentData("avatar", DoterSpecies.FOX)
              }}
            />
          </div>
        </FlexBox>
      </FlexBox>

      <FlexBox
        direction="column"
        gap={SPACING.space2}
        align="center"
        style={{ marginTop: SPACING.space4 }}
      >
        {warningText.length > 0 && (
          <Typography
            variant="bodySmallBold"
            color={JoonUIColor.semantic.alert}
          >
            {warningText}
          </Typography>
        )}
        <Primary3DButton
          onClick={() => {
            if (parentData.nickname.length === 0) {
              setWarningText(t("PARENT_AVATAR_NICKNAME_REQUIRED"))
            } else if (parentData.avatar == null) {
              setWarningText(t("PARENT_AVATAR_AVATAR_REQUIRED"))
            } else {
              trackAnalyticEvent(ANALYTIC_EVENTS.ADD_PARENT_NICKNAME)
              nextStep()
            }
          }}
          text={t("ONBOARDING_CONTINUE")}
          fullWidth
        />
      </FlexBox>
    </OnboardingPageContentWrapper>
  )
}

export default OnboardParentAvatarSection
